import ComingSoon from "components/ComingSoon";
import React from "react";

const GoogleMaps = () => {
  return <ComingSoon />;
};

export default GoogleMaps;
